import { render, staticRenderFns } from "./designer.vue?vue&type=template&id=0aa49ed7&scoped=true&"
import script from "./designer.vue?vue&type=script&lang=js&"
export * from "./designer.vue?vue&type=script&lang=js&"
import style0 from "./designer.vue?vue&type=style&index=0&id=0aa49ed7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa49ed7",
  null
  
)

export default component.exports